import { sync_command_dispatcher } from '@/api/client';

interface SaveTemplateParams {
    company_id: string;
    name: string;
    template: string;
    options: string | null;
}

export class InvoiceTemplateApiRepository {
    /**
     * Save a custom invoice template for a company
     */
    async saveInvoiceTemplate(params: SaveTemplateParams): Promise<any> {
        try {
            const result = await sync_command_dispatcher.dispatch('save.invoice.template', {
                company_id: parseInt(params.company_id),
                name: params.name,
                html: params.template,
                options: params.options || ''
            });

            return result.output;
        } catch (error) {
            console.error('Error saving invoice template:', error);
            throw error;
        }
    }
}
